import Navbar from "../componenets/Navbar";
import Sidebar from "../componenets/Sidebar";
import React, { useState, useEffect}  from 'react';
import TotalSentMessages from "../admin/components/TotalMessages";
import AllcustomersTable from "../admin/components/AllcustomersTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import useKawasans from "../componenets/useKawasans";


import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

//test data for table
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#596CFF",
        fontWeight: "bold",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  

const penjaja = [
"PUSAT PENJAJA JALAN THAVER KG PANDAN",
 "PUSAT PENJAJA JALAN CENDERASARI",
 "JLN RAJA BOT/JLN & LRG HAJJ HUSSEIN",
 "HENTIAN BAS JALAN TUN RAZAK",
 "PUSAT PENJAJA PT43, JALAN HAJI SALLEH",
 "MEDAN SELERA DAMAI JALAN BATU BATA",
 "JALAN BONUS 6 (GERAI BERKUNCI) / MEDAN B",
 "PUSAT PENJAJA AKED IBUKOTA",
 "PP  JALAN 101, TUANKU ABDUL RAHMAN",
 "PP  JALAN 107, TUANKU ABDUL RAHMAN",
 "MEDAN SELERA IKAN BAKAR BELLAMY",
 "PUSAT PENJAJA JALAN IKHLAS",
 "PUSAT PENJAJA TAMAN SALAK JAYA",
 "MEDAN SELERA TAMAN SUNGAI BESI",
 "PUSAT PENJAJA JALAN LOBAK",
 "PUSAT PENJAJA JALAN KUARI",
 "PP LRG ANTARA 495/497, JLN TAR CHOW KIT",
 "PUSAT PENJAJA PUTRA RIA",
 "PUSAT PENJAJA SRI ANGKASA JAYA",
 "PUSAT PENJAJA AKED TUANKU ABDUL RAHMAN",
 "PP TAMAN BOTANI, JALAN CENDERAWASIH",
 "PUSAT PENJAJA JALAN MELAYU/MASID INDIA",
 "PUSAT PENJAJA STATIK PETALING STREET",
 "PP PETALING STREET (JLN HANG LEKIR)",
 "DAPUR BERGERAK",
 "GTJ PARLIMEN TITIWANGSA",
 "GTJ PARLIMEN SETIAWANGSA",
 "GTJ PARLIMEN SEGAMBUT",
 "GTJ PARLIMEN BATU",
 "GTJ PARLIMEN KEPONG",
 "GTJ PARLIMEN WANGSA MAJU",
 "GTJ PARLIMEN BUKIT BINTANG",
 "GTJ PARLIMEN BANDAR TUN RAZAK",
 "GTJ PARLIMEN SEPUTEH",
 "GTJ PARLIMEN CHERAS",
 "GTJ PARLIMEN LEMBAH PANTAI",
 "TERMINATED LOCATION",
 "KIOSK PARLIMEN BUKIT BINTANG",
 "KIOSK PARLIMEN KEPONG",
 "KIOSK PARLIMEN TITIWANGSA",
 "KIOSK PARLIMEN BATU",
 "KIOSK PARLIMEN SEPUTEH",
 "KIOSK PARLIMEN CHERAS",
 "PUSAT KOMUNITI BANDAR TUN RAZAK",
 "PASAR BERBANGUNAN UTC SENTUL",
 "MEDAN SELERA SEKSYEN 4 WANGSA MAJU",
 "PUSAT PENJAJA JALAN DUTA",
 "PUSAT PENJAJA JALAN JEJAKA MALURI",
 "PUSAT PENJAJA METRO PRIMA",
 "PUSAT PENJAJA TPCA, JALAN RAJA MUDA",
 "PUSAT PENJAJA JALAN USAHAWAN",
 "PUSAT PENJAJA DANAU KOTA",
 "MEDAN SELERA PENJAJA TAMAN SETIAWANGSA",
 "PUSAT PENJAJA JALAN MEGA MENDUNG",
 "PUSAT PENJAJA SEKSYEN 10, WANGSA MAJU",
 "PUSAT PENJAJA LOT PT 432 (D'TASEK)",
 "PUSAT PENJAJA D'REJANG",
 "PUSAT PENJAJA PARK & RIDE SUNGAI BESI",
 "PUSAT PENJAJA PT80",
 "PUSAT PENJAJA BANDAR SERI PERMAISURI",
 "PUSAT PENJAJA MUTIARA BANGSAR",
 "KOMPLEKS TUN SAMBANTHAN (PINES) BAZAR",
 "PUSAT PENJAJA AIR PANAS",
 "PP LITTLE INDIA III (PASARAYA SRI KOTA)",
 "PUSAT PENJAJA BAZARIA PANTAI",
 "PP LITTLE INDIA II (KEDAI BUNGA)",
 "PASAR DAN PUSAT PENJAJA RAZAK MANSION",
 "MEDAN SELERA JALAN ROTAN",
 "PP TLK TAMAN SEGAR, CHERAS",
 "PUSAT PENJAJA SELERA MEDAN BUNUS",
 "PP TEMPAT LETAK KERETA JLN BERHALA",
 "KIOSK LAMAN SEJAHTERA PPR SG. BONUS",
 "PUSAT PENJAJA D'LAMAN RASA PEKAN SG BESI",
 "PP SEMENTARA TAMAN KEJIRANAN AIR PANAS",
 "TLK TMN TASIK METROPOLITAN KEPONG",
 "ANJUNG SELERA, JALAN JUJUR",
 "PP LUCKY GARDEN, LORONG ARA 3, BANGSAR",
 "MEDAN SELERA D'TASIK TITIWANGSA",
 "PP BERSEBELAHAN KUIL SRI NAGESWARI",
 "KIOSK TUGU PERINGATAN",
 "PLAZA SUNGAI MULIA GOMBAK",
 "KOMPLEKS MAKAN TANGLIN",
 "BAZARIA WANGSA MAJU (JLN GENTING KELANG)",
 "PASAR BORONG KUALA LUMPUR",
 "PASAR JALAN RAJA BOT/JALAN HAJI HUSSIEN",
 "PASAR BATU 2 1/2, JALAN IPOH",
 "PASAR AIR PANAS",
 "PASAR PUDU",
 "PASAR SENTUL",
 "PASAR DAN PP KG BARU SALAK SELATAN",
 "PASAR SUNGAI BESI",
 "PASAR BESAR TAMAN TUN DR ISMAIL",
 "PASAR TAMAN CHERAS",
 "PASAR DAN PP JLN WIRAWATI KG PANDAN",
 "PASAR DAN PUSAT PENJAJA TMN SERI SENTOSA",
 "PASAR WANGSA MAJU SEK. 1 (KAWASAN 1)",
 "PASAR PT 69 JALAN GENTING KLANG",
 "PASAR ALAM DAMAI",
 "PASAR KG. BATU 5 JALAN IPOH",
 "PASAR BERBANGUNAN KERAMAT MALL",
 "PASAR DAN PP WANGSA MAJU SEKYEN 2",
 "PASAR JALAN KLANG LAMA",
 "PASAR HARIAN SELAYANG KUALA LUMPUR",
 "PUSAT SEMBELIHAN AYAM SEMENTARA",
 "PASAR SEMENTARA CHERAS",
 "KOMPLEKS PASAR RAJA BOT",
 "JALAN SCOTT BRICKFIELDS",
 "USAHAWAN ANAK MUDA KOTA",
  ];
  const perumahan = [
  "PA LOKE YEW 1",
 "PA LOKE YEW 2",
 "PA LOKE YEW 3",
 "PA LOKE YEW 4",
 "PA HANG TUAH",
 "PA SRI SELANGOR 1",
 "PA SRI SELANGOR 2",
 "KOMPLEKS SAN PENG",
 "PA SRI SARAWAK",
 "PA KERINCHI 1A",
 "PPR SRI PANTAI",
 "PPR SRI ANGGERIK",
 "PPR PANTAI RIA",
 "PPR SRI CEMPAKA",
 "PPR SRI ALAM",
 "PPR KG MUHIBBAH",
 "PPR SALAK SELATAN",
 "PPR KG LIMAU",
 "PPR KERINCHI LEMBAH PANTAI",
 "PPR BUKIT JALIL",
 "PPR BUKIT JALIL BLOK L & M",
 "PA SRI KEDAH",
 "PA GOMBAK 2",
 "PA SRI TIOMAN I",
 "PA SETAPAK JAYA 1A",
 "PA PERLIS 1",
 "PA PERLIS 2",
 "PA DESA REJANG",
 "PA WANGSA MAJU R1",
 "PA WANGSA MAJU R10",
 "PA KELOMPOK KUANG & KENARI",
 "PA KOMPLEKS AS-SALAM",
 "PA KOMPLEKS UMMU SAADIAH",
 "PPR JELATEK",
 "PPR SRI SEMARAK",
 "PPR KG BARU AIR PANAS",
 "PPR SG BONUS",
 "PPR WANGSA SARI",
 "PPR GOMBAK SETIA",
 "PPR HILIRAN AMPANG",
  ]
  

const SewaBills = () => {
    const [customers, setCustomers] = useState([]);
    const [area, setArea] = useState([]);
    const [script, setScript] = useState();
    const kawasanOptions = useKawasans('sewa');

    const navigate = useNavigate();

    //select area outstanding
  async function findScriptOutstanding(req){
    console.log(req.target.value)
    if(req.target.value === 'sewa_penjaja'){
      document.getElementById('sewa_penjaja').style.display = "block"
      document.getElementById('sewa_perumahan').style.display = "none"
      setScript(req.target.value)
    }
    else{
      document.getElementById('sewa_perumahan').style.display = "block"
      document.getElementById('sewa_penjaja').style.display = "none"
      setScript(req.target.value)
    }
  }

   //find customers by area
   async function findOutstandingCustomerLocation(req) {
    console.log(req.target.value)
    if(req.target.value){
        document.getElementById('search-table-area_sewa').style.display = "block"
    }
    
    if(!req.target.value){
        document.getElementById('search-table-area_sewa').style.display = "none"
    }
    
    const kod_kawasan = req.target.value
    return fetch('https://globizsystems.com/customers/get_sewa_customer_by_location', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({kod_kawasan})
    })
    .then(response => response.json())
    .then(responseJson => {
      console.log(responseJson);
      setArea(responseJson)
    })
    
   }

   //find outstanding customer 
  async function findSewaCustomer(e) {
  const value = e.target.value;
  console.log(value);

  // Show/hide table
  const table = document.getElementById('search-table-sewa');
  table.style.display = value ? "block" : "none";

  try {
    // Send axios POST with JSON data
    const res = await axios.post(
      'https://globizsystems.com/customers/get_sewa_customer',
      { account_no: value },  
      { headers: { 'Content-Type': 'application/json' } }
    );

    console.log(res.data);
    setCustomers(res.data);   // update state
  } 
  catch (err) {
    console.error("Error fetching customer:", err);
  }
}

  
   async function sendSewaMessage(customers
    ) {
  await axios
      .post("https://globizsystems.com/messages/send_sewa_bill_single", {customers: customers, username: localStorage.getItem('username')})
      .then((response) => {
        console.log(response.data)
        if('success' in response.data){
          swal("Success", "Sent", "success", {
            buttons: false,
            timer: 2000,
          })
          setCustomers([])
          navigate("/messages");
        }else{
          swal("Failed", "Not Sent", "error", {
            buttons: false,
            timer: 2000,
          })
          setCustomers([])
          navigate("/messages");
        }
          
        
      });
    }

    //send outstanding messages
    async function sendOutstandingMessageArea(item) {
        await axios
          .post("https://globizsystems.com/messages/send_bill_single_sewa", {customers: item, username: localStorage.getItem('username')})
          .then((response) => {
            console.log(response.data)
            if('success' in response.data){
              swal("Success", "Sent", "success", {
                buttons: false,
                timer: 2000,
              })
              document.getElementById(`outstanding-${item.id}`).style.display = 'none';
              navigate("/messages");
               
            }else{
              swal("Failed", "Not Sent", "error", {
                buttons: false,
                timer: 2000,
              })
              document.getElementById(item.id).style.display = 'none';
              navigate("/messages");
            }
              
            
          });
        }
      //end outstanding send messages



    return(
        <div className="container-fluid g-3 ">
                <h4 className="colorfix sizefix mx-2">Send Sewa Billings</h4>
                    <div className="card px-2 pt-3 pb-3 mb-4 cardbg">
                        <div className="container-fluid" style={{backgroundColor:"white"}}>
                            <div className="container-fluid px-0 ">
                                <div className="col-12">
                                    <div className="container-fluid pb-4 pt-3 g-3">
                                        <div className="row ">

                                            <Box className="row" component="form" sx={{'& .MuiTextField-root': { m: 1, width: '40ch' }, }} noValidate autoComplete="off" >
                                                <div className="col-5">
                                                    <TextField
                                                    required
                                                    id="outlined-required"
                                                    label="Search Customer by Account Number"
                                                    defaultValue=""
                                                    onChange={findSewaCustomer}
                                                    />
                                                    
                                                </div>
                                                <div className="col-5 mt-2">
                                                  <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Choose Script</InputLabel>
                                                        <Select
                                                          labelId="demo-simple-select-label"
                                                          id="demo-simple-select"
                                                          label="Select Area"
                                                          onChange={findScriptOutstanding}
                                                        >
                                                          <MenuItem value={'sewa_penjaja'}>Penjaja</MenuItem> 
                                                          <MenuItem value={'sewa_perumahan'}>Perumahan</MenuItem>
                                                        </Select>
                                                  </FormControl>
                                                </div>
                                               
                                                <div className="col-8 mt-2 mx-2"  id="sewa_perumahan" style={{display: "none"}}>
                                                <FormControl fullWidth>
                                                      <InputLabel id="demo-simple-select-label">Choose Location (Perumahan)</InputLabel>
                                                      <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Select Area"
                                                        onChange={findOutstandingCustomerLocation}
                                                      >
                                                              {kawasanOptions.perumahan.map((kawasan) => (
                                                                <MenuItem key={kawasan.kod_kawasan} value={kawasan.kod_kawasan}>
                                                                  {kawasan.nama_kawasan}
                                                                </MenuItem>
                                                              ))}
                                                      </Select>
                                                </FormControl>

                                                </div>

                                                <div className="col-8 mt-2 mx-2"  id="sewa_penjaja" style={{display: "none"}}>
                                                  <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Choose Location (Penjaja)</InputLabel>
                                                        <Select
                                                          labelId="demo-simple-select-label"
                                                          id="demo-simple-select"
                                                          label="Penjaja"
                                                          onChange={findOutstandingCustomerLocation}
                                                        >
                                                              {kawasanOptions.penjaja.map((kawasan) => (
                                                                <MenuItem key={kawasan.kod_kawasan} value={kawasan.kod_kawasan}>
                                                                  {kawasan.nama_kawasan}
                                                                </MenuItem>
                                                              ))}
                                                                
                                                                
                                                        </Select>
                                                  </FormControl>
                                                </div>
                                                
                                                
                                            </Box>
                                            
                                                
                                            <div id="search-table-sewa" style={{display: "none"}}>
                                                <legend><b>Sewa Customer</b></legend>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                                        <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>ID</StyledTableCell>
                                                            <StyledTableCell>NAMA</StyledTableCell>
                                                            <StyledTableCell align="center">NO. AKAUN AIR</StyledTableCell>
                                                            <StyledTableCell align="center">NO. TELEFON (1)</StyledTableCell>
                                                            <StyledTableCell align="center">ALAMAT UNIT</StyledTableCell>
                                                            <StyledTableCell>CAJ SEWA</StyledTableCell>
                                                            <StyledTableCell>TUNGGAKAN</StyledTableCell>
                                                            <StyledTableCell>DUE DATE</StyledTableCell>
                                                            <StyledTableCell>ACTIONS</StyledTableCell>
                                                        </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                        
                                                            <StyledTableRow key={customers?.customer_id}>
                                                            
                                                            
                                                            {customers?.id ? (
                                                                    <>
                                                                      <StyledTableCell>{customers?.id}</StyledTableCell>
                                                                      <StyledTableCell>
                                                                          {customers?.name}
                                                                      </StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.no_akaun}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.no_telephone}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.kawasan}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.caj_sewa}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.bills[0]?.tunggakan}</StyledTableCell>
                                                                      <StyledTableCell align="center">{customers?.bills[0]?.due_date}</StyledTableCell>
                                                                      
                                                                      <StyledTableCell align="center">
                                                                  
                                                                      <button className="btn btn-primary" onClick={() => 
                                                                          sendSewaMessage(customers)}>
                                                                          Send
                                                                      </button>
                                                                      </StyledTableCell>
                                                                    
                                                            
                                                                    </>
                                                                    
                                                                ):(
                                                                    <>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        
                                                                        <StyledTableCell size="center" align="center">
                                                                         <h4>no user found</h4>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center"></StyledTableCell>
                                                                        <StyledTableCell size="center" align="center"></StyledTableCell>
                                                                        <StyledTableCell size="center" align="center"></StyledTableCell>
                                                                        <StyledTableCell size="center" align="center"></StyledTableCell>
                                                                        <StyledTableCell size="center" align="center"></StyledTableCell>
                                                                    </>
                                                                
                                                                )}
                                                            
                                                            </StyledTableRow>
                                                       
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                            
                                            <div id='search-table-area_sewa' className="mt-3" style={{display: "none"}}>
                                           
                                            <legend><b>Total Sewa Customer List by Area</b></legend>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                                        <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>ID</StyledTableCell>
                                                            <StyledTableCell>NAMA</StyledTableCell>
                                                            <StyledTableCell align="center">NO. AKAUN AIR</StyledTableCell>
                                                            <StyledTableCell align="center">NO. TELEFON</StyledTableCell>
                                                            <StyledTableCell align="center">KAWASAN SEWAAN</StyledTableCell>
                                                            <StyledTableCell>Caj Sewa</StyledTableCell>
                                                            
                                                            <StyledTableCell>TOTAL DUE AMOUNT</StyledTableCell>
                                                            <StyledTableCell>DUE DATE</StyledTableCell>
                                                            <StyledTableCell>ACTIONS</StyledTableCell>
                                                        </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                        {area?.map(item => (
                                                          <>
                                                             {item.customer ?                                                          
                                                            <StyledTableRow key={item?.id} id={`outstanding-${item.id}`}>
                                                            <StyledTableCell>{item?.id}</StyledTableCell>
                                                            <StyledTableCell>
                                                                {item?.customer?.name}
                                                            </StyledTableCell>
                                                            <StyledTableCell align="center">{item?.no_akaun}</StyledTableCell>
                                                            <StyledTableCell align="center">0{item?.customer?.no_telephone}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.kawasan_sewaan}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.bayaran || 0}</StyledTableCell>
                                                            <StyledTableCell align="center">{item?.tunggakan || 0}</StyledTableCell>
                                                           
                                                            <StyledTableCell align="center">{item?.due_date}</StyledTableCell>
                                                            
                                                            <StyledTableCell align="center">

                                                                <button className="btn btn-primary" onClick={() => 
                                                                    sendOutstandingMessageArea(item)}>
                                                                      Send</button></StyledTableCell>
                                                            </StyledTableRow>
                                                            :
                                                            <>
                                                            </>
                                                              }
                                                          </>
                                                         
                                                        ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            
                                                
                                            </div>
                                            
                                            <br className="pt-4"/>
                                            <hr />
                                            {/* <AllcustomersTable /> */}
                                            
                                            {/* <TotalSentMessages /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    )
}

export default SewaBills;
